<sc-padding fitHeight>
  <sc-flex vertical fitHeight stretchContent>
    <div>
      <sc-flex class="no-field-space">

        @if (shuttleTransportsEnabled) {
          <mat-checkbox name="changeRouteManually" [(ngModel)]="registration.useAsShuttle"
            >
            <sc-dictionary-label
            dictionaryKey="tmc-yard.ui.transport.registration.routingPosition.use-as-shuttle"></sc-dictionary-label>
          </mat-checkbox>
        }

        @if (shuttleTransportsEnabled) {
          <sc-content-spacer></sc-content-spacer>
        }

        <sc-button (click)="reloadRoute()" iconClass="fa-sync-alt"
          dictionaryKey="tmc-yard.ui.transport.registration.routingPosition.action.reload-positions">
        </sc-button>

        <sc-content-spacer></sc-content-spacer>

        <mat-checkbox name="changeRouteManually" [(ngModel)]="registration.changeRouteManually"
          [disabled]="registration.changeRouteManually">
          <sc-dictionary-label
          dictionaryKey="tmc-yard.ui.transport.registration.routingPosition.change-route-manually"></sc-dictionary-label>
        </mat-checkbox>

      </sc-flex>
    </div>
    <sc-content-spacer vertical></sc-content-spacer>
    <sc-flex-fitting-content vertical>
      <sc-scroll-pane>

        <form class="form" #routeForm="ngForm">
          <div class="form-box route-list" cdkDropList (cdkDropListDropped)="drop($event)">
            <sc-tile>
              @for (position of registration.routingPositions; track position) {
                <div class="draggable-form-box grid" cdkDrag
                  [cdkDragDisabled]="!registration.changeRouteManually || position.readonly"
                  >
                  <div class="row-flex" style="grid-column: 1; grid-row: 1;">
                    <mat-form-field class="grow" appearance="fill">
                      <mat-label>
                        <sc-dictionary-label
                        dictionaryKey="tmc-yard.ui.transport.registration.routingPosition.selectStation"></sc-dictionary-label>
                      </mat-label>
                      <input matInput [(ngModel)]="position.stationName" name="{{'station_'+position.index}}" required
                        [readonly]="true">
                      </mat-form-field>
                      <button mat-icon-button [disabled]="!registration.changeRouteManually || position.readonly"
                        (click)="assignStation(position)" class="small-button assign-button"><i
                      class="fa-light fa-sitemap"></i></button>
                    </div>
                    <mat-form-field style="grid-column: 2; grid-row: 1;" class="grow" appearance="fill">
                      <mat-label>
                        <sc-dictionary-label
                        dictionaryKey="tmc-yard.ui.transport.registration.routingPosition.actionType"></sc-dictionary-label>
                      </mat-label>
                      <mat-select [(ngModel)]="position.actionType" name="{{'actionType_'+position.index}}"
                        [disabled]="isActionTypeDisabled(position) || !registration.changeRouteManually || position.readonly">
                        @for (o of actionTypeOptions; track o) {
                          <mat-option value="{{o.option}}">
                            <sc-dictionary-label
                            dictionaryKey="tmc-yard.ui.transport.registration.routingPosition.actionType.{{o.name}}"></sc-dictionary-label>
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <div class="row-flex" style="grid-column: 3; grid-row: 1;">
                      <sc-button [disabled]="!registration.changeRouteManually || position.readonly"
                        dictionaryKey="tmc-yard.ui.transport.registration.routingPosition.assign-tasks"
                        (click)="assignTasks(position)" class="small-button assign-task-button"
                        [ngClass]="{'no-tasks' : !position.tasks || position.tasks.length === 0}">
                        <i class="far fa-tasks"></i>
                      </sc-button>
                    </div>
                    <mat-form-field style="grid-row: 2;"
                      [ngStyle]="cps.isPropertyTrue('visitoverview.register.wait.for.retrieve.enabled', true)?{'grid-column':' 1'}:{'grid-column':' 1 / span 2'}"
                      appearance="fill">
                      <mat-label>
                        <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.cargo"></sc-dictionary-label>
                      </mat-label>
                      <input matInput [(ngModel)]="position.cargo" name="{{'cargo_'+position.index}}"
                        [readonly]="isCargoTypeDisabled(position)" [required]="isCargoRequired(position)"
                        [minlength]="+cps.getPropertyValue('visitoverview.register.minlength.cargo', '0')"
                        [maxlength]="255">
                      </mat-form-field>
                      @if (cps.isPropertyTrue('visitoverview.register.wait.for.retrieve.enabled', true)) {
                        <mat-checkbox style="grid-column: 2; grid-row: 2;" class="form-checkbox"
                          [(ngModel)]="position.waitingForRetrieve" name="{{'waitinForRetrieve_'+position.index}}"
                          [disabled]="isWaitingForRetrieveDisabled(position)  || !registration.changeRouteManually"
                          >
                          <sc-dictionary-label
                          dictionaryKey="tmc-yard.ui.transport.registration.routingPosition.waitingForRetrieve"></sc-dictionary-label>
                        </mat-checkbox>
                      }
                      <mat-form-field style="grid-column: 3; grid-row: 2;" appearance="fill">
                        <mat-label>
                          <sc-dictionary-label
                          dictionaryKey="tmc-yard.ui.transport.registration.routingPosition.predicted-duration"></sc-dictionary-label>
                        </mat-label>
                        <input matInput [(ngModel)]="position.predictedDuration"
                          name="{{'predictedDuration_'+position.index}}"
                          [readonly]="isPredictedDurationDisabled(position) || !registration.changeRouteManually"
                          appPositiveInteger type="number" min="0" required="false">
                        </mat-form-field>
                        <mat-form-field style="grid-column: 1; grid-row: 3;" appearance="fill">
                          <mat-label>
                            <sc-dictionary-label
                            dictionaryKey="tmc-yard.common.entity.station-assignment-strategy"></sc-dictionary-label>
                          </mat-label>
                          <mat-select [(ngModel)]="position.stationAssignmentStrategy"
                            [required]="isStationAssignmentStrategyRequired(position)"
                            name="{{'stationAssignmentStrategy'+position.index}}"
                            [disabled]="isStationAssignmentStrategyDisabled(position)">
                            @for (o of stationAssignmentStrategyOptions; track o) {
                              <mat-option value="{{o}}">
                                <sc-dictionary-label
                                dictionaryKey="tmc-yard.common.entity.station-assignment-strategy.{{o}}"></sc-dictionary-label>
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field style="grid-column: 2 / span 3; grid-row: 3;" appearance="fill">
                          <mat-label>
                            <sc-dictionary-label
                            dictionaryKey="tmc-yard.ui.transport.registration.routingPosition.hint"></sc-dictionary-label>
                          </mat-label>
                          <input matInput [(ngModel)]="position.hint" name="{{'hint_'+position.index}}" [required]="false"
                            [maxLength]="1024" [readonly]="false">
                          </mat-form-field>
                          <div class="button-bar" style="grid-column: 4; grid-row: 1 / span 2;">
                            <button mat-icon-button class="small-button remove-button" (click)="removePosition(position)"
                              [disabled]="!registration.changeRouteManually || position.readonly">
                              <sc-icon iconClass="fa-minus"></sc-icon></button>
                            </div>
                          </div>
                        }
                      </sc-tile>
                    </div>
                  </form>
                  <sc-content-spacer vertical></sc-content-spacer>
                  <sc-flex centered>
                    <sc-action-icon iconClass="fa-circle-plus" (click)="addPosition()" large
                    [disabled]="!registration.changeRouteManually"></sc-action-icon>
                  </sc-flex>
                </sc-scroll-pane>
              </sc-flex-fitting-content>
            </sc-flex>
          </sc-padding>
